<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'subscription', 'name': 'Subscription'}]" />
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="Plan" key="1">
        <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
          <div v-if="currentSubscription == 'PAYG'">
            <a-radio-group name="radioGroup" @change="onChange" :defaultValue="currentSelction" :disabled="true">
              <a-radio value="FREE" class="plan-radio">
                <a-card class="plan-card">
                  <a-card-meta>
                    <div slot="title">
                      Free
                    </div>
                    <div slot="description">Free Forever</div>
                  </a-card-meta>
                </a-card>
              </a-radio>
              <a-radio value="PAYG" class="plan-radio">
                <a-card class="plan-card">
                  <a-card-meta>
                    <div slot="title" v-if="!subscription['cancel_at_period_end']">
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                        style="margin-right:5px;"
                      />Pay as you go
                    </div>
                    <div slot="title" v-else>
                      <a-icon
                        type="exclamation-circle"
                        theme="twoTone"
                        twoToneColor="#eb2f96"
                        style="margin-right:5px;"
                      />Pay as you go
                    </div>
                    <div slot="description" v-if="!subscription['cancel_at_period_end']">Active now</div>
                    <div slot="description" v-else>Pending cancellation</div>
                  </a-card-meta>
                </a-card>
              </a-radio>
            </a-radio-group>
            <div style="margin-top:10px;">
              <div v-if="subscription['cancel_at_period_end']" style="margin-bottom:1em;">
                <a-alert type="error" showIcon>
                  <a-icon type="exclamation-circle" slot="icon" style="fontSize:20px;" />
                  <div slot="message" style="margin: 5px;">Your plan will be cancelled at {{subscription['cancel_at'] | moment}}.</div>
                  <div slot="description" style="margin: 4px;">
                    <p>After that your will be downgraded to a Free plan. You can always reactivate your plan before {{subscription['cancel_at'] | moment}}.</p>
                    <a-popconfirm
                        @confirm="doReactivate"
                        okText="Yes"
                        cancelText="No"
                        placement="right"
                        okType="danger"
                    >
                      <div slot="title">
                        <h3>Are you sure?</h3>
                        <p>Your Pay as you go plan will be reactivated.</p>
                      </div>
                      <a-icon
                        slot="icon"
                        type="question-circle-o"
                        style="color: red"
                      />
                      <a-button
                        type="danger"
                        v-if="currentSubscription === 'PAYG'"
                        :size="size"
                      >Reactivate Pay as you go Plan</a-button>
                    </a-popconfirm>
                  </div>
                </a-alert>
              </div>
              <div v-if="subscription['status'] == 'trialing'" style="margin-bottom:1em;">
                <a-alert type="success" showIcon>
                  <a-icon type="bell" slot="icon" style="fontSize:20px;"/>
                  <div slot="message" style="margin: 5px;">Your free trial will end on {{subscription['current_period_end'] | moment}}.</div>
                </a-alert>
              </div>
              <div>
                <a-spin :spinning="spinning">
                  <a-pricing-slider :currentMAU="initialMau" :showCurrent="true" :disabled="true" />
                </a-spin>
              </div>
              <div v-if="!subscription['cancel_at_period_end']" style="margin-top: 1em;">
                <a-popconfirm
                    @confirm="doCancel"
                    okText="Yes"
                    cancelText="No"
                    placement="right"
                    okType="danger"
                >
                  <div slot="title">
                    <h3>Are you sure?</h3>
                    <p>Your Pay as you go plan will be canceled at end of billing period.</p>
                    <p>After that your will be downgraded to a Free plan.</p>
                  </div>
                  <a-icon
                    slot="icon"
                    type="question-circle-o"
                    style="color: red"
                  />
                  <a-button
                    type="danger"
                    v-if="currentSubscription === 'PAYG'"
                    :size="size"
                    icon="stop"
                  >Cancel Pay as you go Plan</a-button>
                </a-popconfirm>
              </div>
            </div>
          </div>
          <div v-else style="margin-top: 1em;">
            <a-radio-group name="radioGroup" @change="onChange" :defaultValue="currentSelction">
              <a-radio value="FREE" class="plan-radio">
                <a-card class="plan-card">
                  <a-card-meta>
                    <div slot="title">
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                        style="margin-right:5px;"
                      />Free
                    </div>
                    <div slot="description">Active now</div>
                  </a-card-meta>
                </a-card>
              </a-radio>
              <a-radio value="PAYG" class="plan-radio">
                <a-card class="plan-card">
                  <a-card-meta>
                    <div slot="title">
                      Pay as you go
                    </div>
                    <div slot="description">Upgrade now</div>
                  </a-card-meta>
                </a-card>
              </a-radio>
            </a-radio-group>
            <div style="margin-top:10px;" v-if="currentSelction == 'PAYG'">
              <div>
                <a-pricing-slider />
                <a-divider></a-divider>
                <a-payment-methods-tab btnText="Upgrade to Pay as you go Plan" @subscriptionData="subscriptionData" />
              </div>
            </div>
          </div>
        </a-skeleton>
      </a-tab-pane>
      <a-tab-pane tab="Invoices" key="2" v-if="currentSubscription == 'PAYG'">
        <a-invoices-tab />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { formLayoutMixin } from "@/mixins/formLayout";
import APaymentMethodsTab from "@/components/Tab/APaymentMethodsTab";
import AInvoicesTab from "@/components/Tab/AInvoicesTab";
import APricingSlider from "@/components/Slider/APricingSlider";

export default {
  data() {
    return {
      currentSelction: "",
      size: "large",
      loading: true,
      initialMau: 0,
      spinning: true,
      subscription: {}
    };
  },

  mixins: [formLayoutMixin],

  methods: {
    onChange(e) {
      this.currentSelction = e.target.value;
    },
    subscriptionData(data) {
      this.subscription = data;
      this.currentSelction = this.subscription['plan'];
    },
    async doCancel() {
      try {
        this.loading = true;
        await this.$store.dispatch("core/deleteItem", {
          endpoint: `tenants/${this.$auth.session.org}/subscription`,
          uuid: "cancel"
        });
        this.subscription = await this.$store.dispatch("core/getItem", {
          endpoint: `tenants/${this.$auth.session.org}/subscription`,
          uuid: "details"
        });
        this.currentSelction = this.subscription['plan'];
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    async doReactivate() {
      try {
        this.loading = true;
        await this.$store.dispatch("core/getItem", {
          endpoint: `tenants/${this.$auth.session.org}/subscription`,
          uuid: "reactivate"
        });
        this.subscription = await this.$store.dispatch("core/getItem", {
          endpoint: `tenants/${this.$auth.session.org}/subscription`,
          uuid: "details"
        });
        this.currentSelction = this.subscription['plan'];
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  },
  components: {
    APaymentMethodsTab,
    APricingSlider,
    AInvoicesTab
  },
  computed: {
    ...mapGetters("core", ["customer_id", "subscription_id"]),

    currentSubscription() {
      return this.subscription['plan']
    }
  },
  mounted: async function() {
    try {
      var result = this.subscription = await this.$store.dispatch("core/getItem", {
        endpoint: `tenants/${this.$auth.session.org}/subscription`,
        uuid: "mau"
      });
      this.initialMau = result['mau'];
      this.spinning = false;
    } catch (error) {
      console.error(error);
      this.spinning = false;
    }
  },
  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      this.subscription = await this.$store.dispatch("core/getItem", {
        endpoint: `tenants/${this.$auth.session.org}/subscription`,
        uuid: "details"
      });
      this.currentSelction = this.subscription['plan'];
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  filters: {
    moment: function(date) {
      return moment.unix(date).format("MMM Do YYYY");
    },
  }
};
</script>

<style lang="css">
.plan-card {
  background: #e6f7ff;
  width: 240px;
  border: none;
}

.plan-radio {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 5px;
}

.plan-radio > .ant-radio {
  margin: 5px;
}
</style>
